<template>
    <div class="d-flex justify-content-center align-items-center success-page" style="height: 100vh">
        <div class="col-md-5 py-5 rounded-lg success-card">
            <div class="w-100 d-flex pb-5">
                <img class="m-auto" src="~@/assets/checkout/koa-logo-only.svg" alt="">
            </div>
            <div>
                <h1 class="checkout-font-color text-center font-weight-bold">Your order is complete!</h1>
                <p class="checkout-font-color text-center">You will be receiving a confirmation email with order details.</p>
            </div>
            <div class="d-flex pb-5">
                <button type="button" @click="successPage()" class="btn btn-primary continue-button w-25 mx-auto checkout-font h5">
                    Continue Shopping
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"SuccessPage",
}
</script>

<style scoped>
    .success-card {
        background-color: #FFEFF2;
    }
    
    .text-font {
        font-family: "OpenSans";
    }

    .continue-button {
        background-color: #443853;
        font-weight: bold;
        font-size: 0.7rem;
        padding-top: 0.8rem;
        padding-bottom: 0.8rem;
        border-radius: 10px;
        border: 0px solid #D5DCE3;
    }

    .continue-button:hover {
        background-color: #FF6E88;
        font-weight: bold;
        font-size: 0.7rem;
        padding-top: 0.8rem;
        padding-bottom: 0.8rem;
        border-radius: 10px;
        border: 0px solid #D5DCE3;
    }
</style>